<div ngModelGroup="comboSerieEscolar-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboSerieEscolar
                       nome="serieEscolar-{{data}}"
                       [itens]="dados"
                       itemDescricao="descricao"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Série Escolar"
                       label="Série Escolar"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
